const config = {
  apiBaseUrl: "https://james.avik.tech/api",
};

export default config;
